import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import { RouteName } from '@/app/types/app/routes'

import AuthStoreService from '@/store/services/AuthStoreService'

import IconLogout from '@C/ui/icons/IconLogout.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonLogout',
  setup(__props) {

const router = useRouter()
const { t } = useI18n()

const authService = new AuthStoreService()

function logout() {
  authService.logout().then(() => router.push({ name: RouteName.Login }))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "button-logout",
    onClick: logout
  }, [
    _createVNode(IconLogout, { class: "button-logout__icon" }),
    _createTextVNode(" " + _toDisplayString(_unref(t)('common.messages.logout')), 1)
  ]))
}
}

})